import Swiper from 'swiper';
import { Scrollbar, Navigation } from 'swiper/modules';
import Imgix from '../core/Imgix';

class Slider {
    constructor(el) {
        const imgixInstance = new Imgix(); // register new Imgix instance

        this.element = el
        this.imagesRequested = false
        this.swiper = null

        this.options = {
            modules: [Navigation, Scrollbar],
            loop: true,
            slidesPerView: 'auto',
            effect: "fade",
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 'auto', // or a fixed number like 50
                snapOnRelease: true,
            },
            on: {
                slideChange: (swiper) => {
                    if (this.imagesRequested) return
                    // Load all images on first interaction
                    imgixInstance.process(swiper.el)
                    this.imagesRequested = true
                }
            },
        }

        if(this.element.classList.contains('c-slider__slides')) {
            this.options.slidesPerView = 3;
            this.options.loop = false;
            this.options.centeredSlides = false;
            this.options.spaceBetween = 20;
        }

        // Swiper.use(Navigation)

        this.swiper = new Swiper(this.element, this.options);
    }
}

export default Slider
